module.exports = __webpack_public_path__ + "img/placeholder-image-5040-small.f5c755a1.jpg";